import React, { PropsWithChildren } from 'react';
import { Paper, useTheme } from '@mui/material';

export interface SectionProps {
  pad?: boolean;
  withRadius?: boolean;
}

export const Section = ({
  children = '',
  pad = false,
  withRadius = true,
}: PropsWithChildren<SectionProps>) => {
  const theme = useTheme();
  return (
    <Paper
      sx={{
        borderRadius: withRadius ? '8px' : '0px',
        boxShadow: '0px 2px 10px 0px #0000000D',
        padding: pad ? theme.spacing(3) : 0,
      }}
    >
      {children}
    </Paper>
  );
};
